import SectionHeader from "./SectionHeader";

const PRINCIPLES = [
  {
    icon: "ri-search-line",
    title: "精读之后才推荐",
    text: "编辑部坚持逐本阅读，拒绝标题党。只有真正读完并被打动的作品，才会出现在我们的书单里。",
  },
  {
    icon: "ri-flask-line",
    title: "不随大流",
    text: "热门我们报，冷门我们也淘。避开流量陷阱，把那些被低估的好作品带到你面前。",
  },
  {
    icon: "ri-heart-3-line",
    title: "对时间负责",
    text: "你的阅读时间很宝贵。我们用一句话讲清楚它值不值得读，帮你少踩坑、少走弯路。",
  },
];

export default function About() {
  return (
    <section id="关于" className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <SectionHeader
          eyebrow="关于小秘"
          eyebrowTone="primary"
          title={
            <>
              为什么叫「小秘漫画网」<span className="text-primary-600">？</span>
            </>
          }
          subtitle="因为我们想成为你口袋里那个随叫随到的漫画小秘书——你只要说一声想看什么，我们就把最值得的那一部递到你手上。"
        />

        <div className="grid items-start gap-10 lg:grid-cols-2 lg:gap-16">
          <div className="flex flex-col gap-6">
            <p className="text-sm leading-relaxed text-foreground-700 md:text-base">
              小秘漫画网诞生于编辑部一次小小的抱怨：「想找个好漫画怎么这么难？」热门榜单鱼龙混杂，冷门佳作又无人问津。
              于是我们决定自己动手，把「编辑推荐」「每日精选」「秘书严选」做成了一个个可以天天更新的栏目。
            </p>
            <p className="text-sm leading-relaxed text-foreground-700 md:text-base">
              我们相信，好的推荐不是冰冷的排行榜，而是一种有温度的分享。每一部作品背后的推荐语，都是一位编辑真实的阅读体验。
              不夸大、不虚高，只把真心觉得值得的东西说给你听。
            </p>
            <div className="flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-5">
              <div className="flex items-center gap-2 text-sm font-bold text-foreground-950">
                <i className="ri-mail-send-line text-primary-600" aria-hidden="true"></i>
                联系编辑部
              </div>
              <p className="text-sm text-foreground-600">
                投稿、反馈或合作，欢迎写信给我们：
                <a
                  href="mailto:hello@xiaomi-comic.cn"
                  className="ml-1 font-medium text-primary-600 hover:text-primary-700"
                >
                  hello@xiaomi-comic.cn
                </a>
              </p>
              <p className="text-xs text-foreground-500">工作日 24 小时内回复，周末请耐心等候。</p>
            </div>
          </div>

          <div className="grid gap-5 sm:grid-cols-1">
            {PRINCIPLES.map((p) => (
              <div
                key={p.title}
                className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-primary-500 text-xl text-background-50">
                  <i className={p.icon} aria-hidden="true"></i>
                </span>
                <div>
                  <h3 className="text-base font-bold text-foreground-950">{p.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-600">{p.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}